<template>
    <div class="wrapper">
        <NavBar />
        <Menu />
        <!-- Spinner Start -->
        <div id="spinner" v-if="halamanloading"
            class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
            style="opacity: 0.5;">
            <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <!-- Spinner End -->
        <div class="content-wrapper py-3">
            <div class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-6 wow fadeInDown">
                            <h5>Pengaturan</h5>
                        </div>
                        <div class="col-sm-6 wow fadeInDown">
                            <ol class="breadcrumb float-sm-right">
                                <li class="breadcrumb-item"><a href="/Dashboard">Home </a></li>
                                <li class="breadcrumb-item"><a href="/Monev">Monev Proyek</a></li>
                                <li class="breadcrumb-item active">Pengaturan Monev KPI Proyek</li>
                            </ol>
                        </div>
                    </div><!-- /.row -->
                </div><!-- /.container-fluid -->
            </div>
            <!-- /.content-header -->
            <div class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-sm-12 wow fadeInDown">
                            <div class="card cardputih2">
                                <div class="card-header border-transparent">
                                    <h3 class="card-title">Form Input Monev KPI Proyek</h3>
                                    <div class="card-tools">
                                        <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                            <i class="fas fa-minus"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="card-body p-3">
                                    <div class="row">
                                        <div class="col-sm-12 float-left">
                                            <label>PIU <small class="text-info"> (*wajib
                                                    dipilih)</small></label>
                                            <v-select :options="id_user" :reduce="(label) => label.code" label="label"
                                                v-model="defaultSelectedid_user" @update:modelValue="onid_userChange"
                                                v-bind:class="{ disabled: true }"></v-select>
                                        </div>
                                        <div class="col-sm-12">&nbsp;</div>
                                        <div class="col-sm-12 float-left">
                                            <label>Nama Kegiatan PMIS <small class="text-info"> (*wajib
                                                    dipilih)</small></label>
                                            <v-select :options="idpmis" :reduce="(label) => label.code" label="label"
                                                v-model="defaultSelectedidpmis" @update:modelValue="onidpmisChange"
                                                v-bind:class="{ disabled: true }"></v-select>
                                        </div>
                                        <div class="col-sm-12">&nbsp;</div>
                                        <div class="col-sm-12">
                                            <label>Nama Kegiatan <small class="text-info"> (*wajib
                                                    diisi)</small></label>
                                            <div class="input-group mb-3">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text"><i
                                                            class="fab fa-creative-commons-share"></i></span>
                                                </div>
                                                <input type="text" class="form-control form-control-sm"
                                                    id="Nama_Kegiatan" name="Nama_Kegiatan" placeholder="Nama Kegiatan"
                                                    v-model="Nama_Kegiatan" disabled>
                                            </div>
                                        </div>
                                        <div class="col-sm-12 float-left">
                                            <label>Lokasi<small class="text-info"> (*wajib
                                                    dipilih)</small></label>
                                            <v-select :options="lokasi" :reduce="(label) => label.code" label="label"
                                                v-model="defaultSelectedlokasi" @update:modelValue="onlokasiChange"
                                                v-bind:class="{ disabled: true }"></v-select>
                                        </div>
                                        <div class="col-sm-12">&nbsp;</div>
                                        <div class="col-sm-12 float-left">
                                            <div class="table-responsive table-wrapper">
                                                <table class="table m-0" id="tabeldata" style="font-size: small;">
                                                    <thead>
                                                        <tr>
                                                            <th style="width: 10px;">No</th>
                                                            <th style="width: 100px;">Indikator</th>
                                                            <th style="width: 20px;">Satuan</th>
                                                            <th style="width: 10px;">Kelengkapan</th>
                                                            <th style="width: 200px;">Data</th>
                                                        </tr>
                                                    </thead>
                                                    <template v-for="(datalist, urutlist) in PDO" :key="urutlist">
                                                        <tbody>
                                                            <tr>
                                                                <td>
                                                                    {{ urutlist + 1 }}
                                                                </td>
                                                                <td>
                                                                    {{ datalist.Indikator }}
                                                                </td>
                                                                <td>
                                                                    {{ datalist.Satuan }}
                                                                </td>
                                                                <td>
                                                                    <div class="form-group"
                                                                        v-for="(dataceklist, urutceklistlist) in datalist.Ceklist"
                                                                        :key="urutceklistlist">
                                                                        <div class="form-check">
                                                                            <input class="form-check-input"
                                                                                type="checkbox"
                                                                                :id="'checkbox' + datalist.id + '-' + dataceklist.id"
                                                                                @click="cekpilih(datalist.id)"
                                                                                :checked="dataceklist.Data">
                                                                            <label class="form-check-label">{{
                                                                                dataceklist.Kelengkapan }}</label>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td class="text-center"
                                                                    v-if="datalist.Satuan == 'Number' || datalist.Satuan == 'Nomor' || datalist.Satuan == 'Persentase' || datalist.Satuan == 'Kilometer' || datalist.Satuan == 'Jumlah'">
                                                                    <template
                                                                        v-for="(dataceklistinput, urutceklistlistinput) in datalist.CekInput"
                                                                        :key="urutceklistlistinput">
                                                                        <label>{{ urutceklistlistinput + 1 }}. {{
                                                                            dataceklistinput.Kelengkapan }}</label>
                                                                        <input type="number"
                                                                            class="form-control form-control-sm"
                                                                            :id="'filenya_pdo' + datalist.id + '-' + dataceklistinput.id"
                                                                            :name="'filenya_pdo' + datalist.id + '-' + dataceklistinput.id"
                                                                            :value="datalist.Isi[urutceklistlistinput]"
                                                                            :disabled="datalist.Disabled"><br>
                                                                    </template>
                                                                </td>
                                                                <td class="text-center"
                                                                    v-else-if="datalist.Satuan == 'Dokumen'">
                                                                    <template
                                                                        v-for="(dataceklistinput, urutceklistlistinput) in datalist.CekInput"
                                                                        :key="urutceklistlistinput">
                                                                        <a :href="folder_file+datalist.Isi[urutceklistlistinput]" v-if="datalist.Isi[urutceklistlistinput] != ''">{{ urutceklistlistinput + 1 }}. {{
                                                                            dataceklistinput.Kelengkapan }}</a>
                                                                        <label v-else>{{ urutceklistlistinput + 1 }}. {{
                                                                            dataceklistinput.Kelengkapan }}</label>
                                                                        <!--IKON PETA 1-->
                                                                        <div class="col-sm-12">
                                                                            <label>File<small class="text-info">
                                                                                    (*pdf)</small>
                                                                            </label>
                                                                            <div class="input-group mb-3">
                                                                                <div class="input-group-prepend">
                                                                                    <span class="input-group-text"><i
                                                                                            class="far fa-file-image"></i></span>
                                                                                </div>
                                                                                <input type="file"
                                                                                    class="form-control form-control-sm"
                                                                                    :id="'fileToUploadfilenya_pdo' + datalist.id + '-' + dataceklistinput.id"
                                                                                    :name="'fileToUploadfilenya_pdo' + datalist.id + '-' + dataceklistinput.id"
                                                                                    placeholder="fileToUpload"
                                                                                    style="font-size: smaller;"
                                                                                    accept="application/pdf"
                                                                                    :disabled="datalist.Disabled">
                                                                                <input type="hidden"
                                                                                    class="form-control form-control-sm"
                                                                                    :id="'filenya_pdo' + datalist.id + '-' + dataceklistinput.id"
                                                                                    :name="'filenya_pdo' + datalist.id + '-' + dataceklistinput.id"
                                                                                    :value="datalist.Isi[urutceklistlistinput]"
                                                                                    placeholder="File Pendukung">
                                                                            </div>
                                                                        </div>
                                                                        <div class="col-sm-12">
                                                                            <label>Opsi</label>
                                                                            <div class="row">
                                                                                <div class="col-sm-12">
                                                                                    <div class="progress">
                                                                                        <div class="progress-bar"
                                                                                            role="progressbar"
                                                                                            aria-valuenow="0"
                                                                                            aria-valuemin="0"
                                                                                            aria-valuemax="100"
                                                                                            style="width:0%"
                                                                                            :id="'persennyafilenya_pdo' + datalist.id + '-' + dataceklistinput.id">
                                                                                            <span
                                                                                                :id="'tulisanpersenfilenya_pdo' + datalist.id + '-' + dataceklistinput.id">0%</span>
                                                                                        </div>
                                                                                    </div>
                                                                                    <br>
                                                                                    <span class="text-success"
                                                                                        :id="'suksesnyafilenya_pdo' + datalist.id + '-' + dataceklistinput.id"></span>
                                                                                </div>
                                                                                <div class="col-sm-12 text-center">
                                                                                    <button type="button"
                                                                                        :id="'uploadfilenya_pdo' + datalist.id + '-' + dataceklistinput.id"
                                                                                        class="btn btn-warning btn-sm lebar text-white"
                                                                                        :disabled="datalist.Disabled"
                                                                                        @click="uploadfile('filenya_pdo' + datalist.id + '-' + dataceklistinput.id, 'application/pdf')">Upload
                                                                                        File</button>
                                                                                    <button type="button"
                                                                                        :id="'hapusfilenya_pdo' + datalist.id + '-' + dataceklistinput.id"
                                                                                        class="btn btn-danger btn-sm lebar"
                                                                                        :disabled="datalist.Disabled"
                                                                                        @click="clearfilepeta('filenya_pdo' + datalist.id + '-' + dataceklistinput.id)">Hapus
                                                                                        File</button>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <!--IKON PETA 1 END-->
                                                                        <div class="col-sm-12">&nbsp;</div>
                                                                    </template>
                                                                </td>
                                                                <td v-else>
                                                                    <div class="form-check">
                                                                        <input class="form-check-input" type="radio"
                                                                            :id="'filenya_pdocek1' + datalist.id"
                                                                            :name="'filenya_pdo' + datalist.id"
                                                                            :disabled="datalist.Disabled">
                                                                        <label class="form-check-label">Ya</label>
                                                                    </div>
                                                                    <div class="form-check">
                                                                        <input class="form-check-input" type="radio"
                                                                            :id="'filenya_pdocek2' + datalist.id"
                                                                            :name="'filenya_pdo' + datalist.id"
                                                                            :disabled="datalist.Disabled">
                                                                        <label class="form-check-label">Tidak</label>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </template>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-footer p-3">
                                    <button type="button" class="btn btn-sm btn-success3 float-left text-white lebar2"
                                        @click="simpan()" v-if="(secretencData == 'Tambah')" data-toggle="tooltip"
                                        data-placement="left" title="Simpan data.."><i class="fas fa-plus-square"></i>
                                        Simpan</button>
                                    <button type="button" class="btn btn-sm btn-success3 float-left text-white lebar2"
                                        v-if="(secretencData != 'Tambah')" @click="update()" data-toggle="tooltip"
                                        data-placement="left" title="Update data.."><i class="fa fa-check-circle"></i>
                                        Update</button>
                                    <button type="button" class="btn btn-sm btn-danger3 float-left text-white lebar2"
                                        @click="batalproses()" data-toggle="tooltip" data-placement="left"
                                        title="Batalkan proses.."><i class="fas fa-window-close"></i>
                                        Batal</button>
                                </div>
                                <div class="card-footer p-3">&nbsp;</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
import $ from 'jquery';
import axios from 'axios';
import vSelect from 'vue-select';
import swal from 'sweetalert2';
import CryptoJS from 'crypto-js';
import { useRoute } from 'vue-router';
import { watch } from 'vue';
import { quillEditor } from 'vue3-quill';
import Footer from "../../componen/Footer.vue";
import NavBar from "../../componen/NavBar.vue";
import Menu from "../../componen/Menu.vue";

import VueApexCharts from "vue3-apexcharts";
window.Apex.chart = { fontFamily: "Poppins-SemiBold, Arial, sans-serif" };
export default {
    setup() {
        const route = useRoute()
        watch(() => route.name, () => {
        });

        return { route };
    },
    components: {
        Footer, NavBar, Menu, vSelect, swal, quillEditor
    },
    data() {
        return {
            halamanloading: true,
            iduser: JSON.parse(localStorage.getItem("usistem")),
            leveluser: JSON.parse(localStorage.getItem("lsistem")),
            namauser: JSON.parse(localStorage.getItem("nmusistem")),
            secretencData: decodeURIComponent(CryptoJS.AES.decrypt(this.route.params.id, 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString(CryptoJS.enc.Utf8)),
            Nama_Kegiatan: '',
            Komponen: '',
            id_user: [],
            dataid_user: [],
            defaultSelectedid_user: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedid_user: 0,

            jenispekerjaan: [],
            datajenispekerjaan: [],
            defaultSelectedjenispekerjaan: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedjenispekerjaan: 0,

            idpmis: [],
            dataidpmis: [],
            defaultSelectedidpmis: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedidpmis: 0,

            lokasi: [],
            datalokasi: [],
            defaultSelectedlokasi: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedlokasi: 0,

            Penyedia: '',
            Mulai: '',
            Selesai: '',
            Kontrak: 0,
            Nilai: 0,
            Adendum: '',
            OWP: '',
            AWP: [],
            DIPA: [],
            PDO: [],
            datatahun: [],
            jumlahtahun: 0,
            Target: 0,
            Capaian: 0,
            Realisasi: 0,
            TanggalData: new Date(),
            Keterangan: '',
            tahapanpekerjaan: [],
            filenya_pdo: '',
            LATITUDE: '',
            LONGITUDE: '',
            validasi: false,
            project_id: process.env.VUE_APP_PROJECT_ID,
            folder_file: process.env.VUE_APP_URL_API + 'pdofile_parastapainnovation-PDF?f=',
        }
    },
    methods: {
        cekpilih(id) {
            //alert(id);
            var cekbox = document.querySelectorAll('[id^="checkbox' + id + '-"]');
            //alert(cekbox.length);
            var kata = '';
            for (let i = 0; i < cekbox.length; i++) {
                if (document.getElementById('checkbox' + id + '-' + i).checked == true) {
                    kata = kata + 'true';
                }
                else {
                    kata = kata + 'false';
                }

                if (kata.includes("false")) {
                    try {
                        var elemennya = document.querySelectorAll('[id^="filenya_pdo' + id + '-"]');
                        for (let c = 0; c < elemennya.length; c++) {
                            document.getElementById('filenya_pdo' + id + '-' + c).disabled = true;
                        }
                    } catch (error) {

                    }
                    try {
                        var elemennya = document.querySelectorAll('[id^="filenya_pdocek1' + id + '-"]');
                        for (let c = 0; c < elemennya.length; c++) {
                            document.getElementById('filenya_pdocek1' + id + '-' + c).disabled = true;
                        }
                        //document.getElementById('filenya_pdocek1' + id).disabled = true;
                    } catch (error) {

                    }
                    try {
                        var elemennya = document.querySelectorAll('[id^="filenya_pdocek2' + id + '-"]');
                        for (let c = 0; c < elemennya.length; c++) {
                            document.getElementById('filenya_pdocek2' + id + '-' + c).disabled = true;
                        }
                        //document.getElementById('filenya_pdocek2' + id).disabled = true;
                    } catch (error) {

                    }
                    try {
                        var elemennya = document.querySelectorAll('[id^="fileToUploadfilenya_pdo' + id + '-"]');
                        for (let c = 0; c < elemennya.length; c++) {
                            document.getElementById('fileToUploadfilenya_pdo' + id + '-' + c).disabled = true;
                        }
                        //document.getElementById('fileToUploadfilenya_pdo' + id).disabled = true;
                    } catch (error) {

                    }
                    try {
                        var elemennya = document.querySelectorAll('[id^="uploadfilenya_pdo' + id + '-"]');
                        for (let c = 0; c < elemennya.length; c++) {
                            document.getElementById('uploadfilenya_pdo' + id + '-' + c).disabled = true;
                        }
                        //document.getElementById('uploadfilenya_pdo' + id).disabled = true;
                    } catch (error) {

                    }
                    try {
                        var elemennya = document.querySelectorAll('[id^="hapusfilenya_pdo' + id + '-"]');
                        for (let c = 0; c < elemennya.length; c++) {
                            document.getElementById('hapusfilenya_pdo' + id + '-' + c).disabled = true;
                        }
                        //document.getElementById('hapusfilenya_pdo' + id).disabled = true;
                    } catch (error) {

                    }
                }
                else {
                    try {
                        var elemennya = document.querySelectorAll('[id^="filenya_pdo' + id + '-"]');
                        for (let c = 0; c < elemennya.length; c++) {
                            document.getElementById('filenya_pdo' + id + '-' + c).disabled = false;
                        }
                    } catch (error) {

                    }
                    try {
                        var elemennya = document.querySelectorAll('[id^="filenya_pdocek1' + id + '-"]');
                        for (let c = 0; c < elemennya.length; c++) {
                            document.getElementById('filenya_pdocek1' + id + '-' + c).disabled = false;
                        }
                        //document.getElementById('filenya_pdocek1' + id).disabled = false;
                    } catch (error) {

                    }
                    try {
                        var elemennya = document.querySelectorAll('[id^="filenya_pdocek2' + id + '-"]');
                        for (let c = 0; c < elemennya.length; c++) {
                            document.getElementById('filenya_pdocek2' + id + '-' + c).disabled = false;
                        }
                        //document.getElementById('filenya_pdocek2' + id).disabled = false;
                    } catch (error) {

                    }
                    try {
                        var elemennya = document.querySelectorAll('[id^="fileToUploadfilenya_pdo' + id + '-"]');
                        for (let c = 0; c < elemennya.length; c++) {
                            document.getElementById('fileToUploadfilenya_pdo' + id + '-' + c).disabled = false;
                        }
                        //document.getElementById('fileToUploadfilenya_pdo' + id).disabled = false;
                    } catch (error) {

                    }
                    try {
                        var elemennya = document.querySelectorAll('[id^="uploadfilenya_pdo' + id + '-"]');
                        for (let c = 0; c < elemennya.length; c++) {
                            document.getElementById('uploadfilenya_pdo' + id + '-' + c).disabled = false;
                        }
                        //document.getElementById('uploadfilenya_pdo' + id).disabled = false;
                    } catch (error) {

                    }
                    try {
                        var elemennya = document.querySelectorAll('[id^="hapusfilenya_pdo' + id + '-"]');
                        for (let c = 0; c < elemennya.length; c++) {
                            document.getElementById('hapusfilenya_pdo' + id + '-' + c).disabled = false;
                        }
                        //document.getElementById('hapusfilenya_pdo' + id).disabled = false;
                    } catch (error) {

                    }
                }
            }
        },
        uploadfile(idnya, tipenya) {
            var elmnt = document.getElementById("fileToUpload" + idnya);
            try {
                var namanya = elmnt.files[0].name;
                //alert(idnya);
                //alert(elmnt.files[0]['type'].toUpperCase());
                if (tipenya == 'image/*') {
                    if ((elmnt.files[0]['type'].toUpperCase() != 'IMAGE/JPG') && (elmnt.files[0]['type'].toUpperCase() != 'IMAGE/JPEG') && (elmnt.files[0]['type'].toUpperCase() != 'IMAGE/PNG') && (elmnt.files[0]['type'].toUpperCase() != 'IMAGE/GIF')) {
                        document.getElementById('suksesnya' + idnya).innerHTML = '*file harus format gambar';
                        return;
                    }
                }
                else {
                    if (elmnt.files[0]['type'] != tipenya) {
                        document.getElementById('suksesnya' + idnya).innerHTML = '*file harus format pdf';
                        return;
                    }
                }
            } catch (error) {
                document.getElementById('suksesnya' + idnya).innerHTML = '*pilih file terlebih dahulu';
                return;
            }
            var fd = new FormData();
            fd.append("fileToUpload", elmnt.files[0], elmnt.files[0].name);
            fd.append("folderToUpload", "filenya_pdo");
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("parastapainnovation-FilesUpload", fd, {
                onUploadProgress: function (uploadEvent) {
                    document.getElementById('persennya' + idnya).style.width = Math.round((uploadEvent.loaded / uploadEvent.total) * 100) + "%";
                    document.getElementById('tulisanpersen' + idnya).innerHTML = Math.round((uploadEvent.loaded / uploadEvent.total) * 100) + "%";
                }
            }).then(
                function (res) {
                    document.getElementById('suksesnya' + idnya).innerHTML = res.data.message;
                    if (res.data.filename != undefined) {
                        document.getElementById(idnya).value = res.data.filename;
                    }
                }
            ).catch(function (e) {
                document.getElementById('suksesnya' + idnya).innerHTML = res.data.message;
                document.getElementById(idnya).value = '';
                console.log(e);
            }
            )
        },
        clearfilepeta(idnya) {
            if (document.getElementById(idnya).value == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'File Tidak Tersedia',
                });
                return false;
            }

            var fd = new FormData();
            fd.append("folderToUpload", "filenya_pdo");
            fd.append("filenya", document.getElementById(idnya).value);
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("parastapainnovation-FilesDeleted", fd).then(
                Response => {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: Response.data.message,
                    });
                    document.getElementById(idnya).value == '';
                    this.filenya_regulasi = '';
                }
            ).catch(function (error) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: error
                });
            }
            )

            document.getElementById('fileToUpload' + idnya).value = '';
            document.getElementById(idnya).value = '';
            document.getElementById('persennya' + idnya).style.width = "0%";
            document.getElementById('tulisanpersen' + idnya).innerHTML = "0%";
            document.getElementById('suksesnya' + idnya).innerHTML = '';
            return false;
        },
        formattulisrupiah(kodenya) {
            var rupiah = document.getElementById(kodenya);
            rupiah.addEventListener('keyup', function (e) {
                // tambahkan 'Rp.' pada saat form di ketik
                // gunakan fungsi formatRupiah() untuk mengubah angka yang di ketik menjadi format angka
                rupiah.value = formatRupiah(this.value, '');
            });

            /* Fungsi formatRupiah */
            function formatRupiah(angka, prefix) {
                var separator = '';
                var number_string = angka.replace(/[^,\d]/g, '').toString(),
                    split = number_string.split(','),
                    sisa = split[0].length % 3,
                    rupiah = split[0].substr(0, sisa),
                    ribuan = split[0].substr(sisa).match(/\d{3}/gi);

                // tambahkan titik jika yang di input sudah menjadi angka ribuan
                if (ribuan) {
                    separator = sisa ? '.' : '';
                    rupiah += separator + ribuan.join('.');
                }

                rupiah = split[1] != undefined ? rupiah + ',' + split[1] : rupiah;
                return prefix == undefined ? rupiah : (rupiah ? rupiah : '');
            }
        },

        async ambildatareff() {
            this.halamanloading = true;
            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            await mainAPI5.get("parastapainnovation_userproject-GetPIU?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.dataid_user = [];
                        this.id_user = [];
                        this.dataid_user = Response.data.content.data;
                        this.dataid_user.forEach((item) => {
                            this.id_user.push({
                                label: item.nama_satker,
                                code: this.dataid_user.indexOf(item) + 1,
                                tag: item.user_id,
                            });
                        });
                        this.id_user.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });


            await mainAPI5.get("parastapainnovation_jenispekerjaan-GetJenisPekerjaan?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datajenispekerjaan = [];
                        this.jenispekerjaan = [];
                        this.datajenispekerjaan = Response.data.content.data;
                        this.datajenispekerjaan.forEach((item) => {
                            this.jenispekerjaan.push({
                                label: item.nama,
                                code: this.datajenispekerjaan.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.jenispekerjaan.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            await mainAPI5.get("parastapainnovation_tahapanpekerjaan-GetTahapanPekerjaan?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.dataStatus_pekerjaan = [];
                        this.Status_pekerjaan = [];
                        this.dataStatus_pekerjaan = Response.data.content.data;
                        this.dataStatus_pekerjaan.forEach((item) => {
                            this.Status_pekerjaan.push({
                                label: item.nama,
                                code: this.dataStatus_pekerjaan.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.Status_pekerjaan.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            await mainAPI5.get("parastapainnovation_lokasi-KotaProyek?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datalokasi = [];
                        this.lokasi = [];
                        this.datalokasi = Response.data.content.data;
                        this.datalokasi.forEach((item) => {
                            this.lokasi.push({
                                label: item.nama,
                                code: this.datalokasi.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.lokasi.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });


        },
        onid_userChange(a) {
            try {
                this.selectedid_user = this.id_user[a].tag;
            }
            catch (err) {
                return;
            }
            this.pilihKegiatanPMIS();
        },
        onjenispekerjaanChange(a) {
            try {
                this.selectedjenispekerjaan = this.jenispekerjaan[a].tag;
            }
            catch (err) {
                return;
            }
            this.AmbilTahapanPekerjaan();

            //alert(this.selectedjenispekerjaan);
        },
        onidpmisChange(a) {
            try {
                this.selectedidpmis = this.idpmis[a].tag;
            }
            catch (err) {
                return;
            }
        },
        async sinkorinasi() {
            if ((this.selectedid_user == '') || (this.selectedid_user == '0')) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Pilih PIU',
                });
                document.getElementById('customCheckboxSinkronisasi').checked = false;
                return false;
            }
            if ((this.selectedidpmis == '') || (this.selectedidpmis == '0')) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Pilih Kegiatan PMIS',
                });
                document.getElementById('customCheckboxSinkronisasi').checked = false;
                return false;
            }

            this.halamanloading = true;
            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            await mainAPI5.get("parastapainnovationmonev-SinkronisasiPMIS?random=" + random + "&project_id=" + this.project_id + "&id_user=" + this.selectedid_user + "&id_kegiatan=" + this.selectedidpmis).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.OWP = this.G_numFormat(Response.data.content.data[0].anggaran_owp);
                        this.AWP = Response.data.content.data[0].awp;
                        this.DIPA = Response.data.content.data[0].dipa;
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });
            //alert(this.selectedidpmis);
        },
        onlokasiChange(a) {
            try {
                this.selectedlokasi = this.lokasi[a].tag;
            }
            catch (err) {
                return;
            }
        },
        initialize() {
            //Initialize Select2 Elements
            $(".select2").select2();

            //Initialize Select2 Elements
            $(".select2bs4").select2({
                theme: "bootstrap4",
            });
            $('[data-mask]').inputmask();
            //$('#summernote').summernote();
        },
        getOtentifikasi() {
            var time = Date.parse(localStorage.getItem("tsistem"));
            var timeakhir = time + (3 * 60 * 60 * 1000);
            var timesekarang = Date.parse(new Date());
            if (timesekarang > timeakhir) {
                this.ClearlocalStorage();
            }
            this.halamanloading = false;
        },
        ontabelChange(a) {
            try {
                this.selectedtabel = this.tabel[a].tag;
            }
            catch (err) {
                return;
            }
        },
        batalproses() {
            var kode = encodeURIComponent(CryptoJS.AES.encrypt(this.secretencData, 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
            window.location.replace("/Monev/" + kode);
        },
        async AmbilTahapanPekerjaan() {
            var mainAPIDataSingelcari = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            this.tahapanpekerjaan = [];
            await mainAPIDataSingelcari.get("parastapainnovation_tahapanpekerjaan-GetAll?random=" + random + "&project_id=" + this.project_id + "&jenis_pekerjaan=" + this.selectedjenispekerjaan + "&id_kegiatan=" + this.secretencData).then(
                Responsecari => {
                    this.tahapanpekerjaan = Responsecari.data.content.data;
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

        },
        async pilihKegiatanPMIS() {
            this.halamanloading = true;
            var mainAPIDataSingelcari = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            await mainAPIDataSingelcari.get("parastapainnovation_idkegiatanpmis-GetIdKegiatanPMIS?random=" + random + "&project_id=" + this.project_id + "&id_user=" + this.selectedid_user).then(
                Responsecari => {
                    this.dataidpmis = [];
                    this.idpmis = [];
                    this.dataidpmis = Responsecari.data.content.data;
                    this.dataidpmis.forEach((item) => {
                        this.idpmis.push({
                            label: item.nama_kegiatan,
                            code: this.dataidpmis.indexOf(item) + 1,
                            tag: item.id_kegiatan,
                        });
                    });
                    this.idpmis.unshift({
                        label: 'Pilih Salah Satu',
                        code: 0,
                        tag: '',
                    });
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });


        },
        async AmbilDataSingel() {
            this.halamanloading = true;
            var mainAPIDataSingel = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var mainAPIDataSingelcari = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var tmp = this.secretencData.split("_");
            var terpilih = tmp[0];
            var random = Math.random();
            await mainAPIDataSingel.get("parastapainnovationmonev-GetKPIByID?id=" + terpilih + "&random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.Nama_Kegiatan = Response.data.content.data[0].Nama_Kegiatan;
                    this.Komponen = Response.data.content.data[0].Komponen;
                    var id_userpmis = Response.data.content.data[0].id_user;
                    this.defaultSelectedid_user = {
                        code: Response.data.content.data[0].id_user,
                        label: Response.data.content.data[0].nama_satker,
                        tag: Response.data.content.data[0].id_user,
                    };
                    this.selectedid_user = Response.data.content.data[0].id_user;
                    this.defaultSelectedjenispekerjaan = {
                        code: Response.data.content.data[0].tipe_work,
                        label: Response.data.content.data[0].Kategori,
                        tag: Response.data.content.data[0].tipe_work,
                    };
                    this.defaultSelectedStatus_pekerjaan = {
                        code: Response.data.content.data[0].idstatuspekerjaan,
                        label: Response.data.content.data[0].Status_pekerjaan,
                        tag: Response.data.content.data[0].idstatuspekerjaan,
                    };
                    this.defaultSelectedlokasi = {
                        code: Response.data.content.data[0].Lokasi,
                        label: Response.data.content.data[0].namalokasi,
                        tag: Response.data.content.data[0].Lokasi,
                    };

                    this.selectedlokasi = Response.data.content.data[0].Lokasi;

                    if (Response.data.content.data[0].Lokasi == '') {
                        this.defaultSelectedlokasi = {
                            code: 0,
                            label: 'Pilih Salah Satu',
                            tag: '',
                        };
                        this.selectedlokasi = '';
                    }

                    this.selectedjenispekerjaan = Response.data.content.data[0].tipe_work;
                    this.selectedStatus_pekerjaan = Response.data.content.data[0].idstatuspekerjaan;

                    this.tahapanpekerjaan = [];
                    mainAPIDataSingelcari.get("parastapainnovation_tahapanpekerjaan-GetAll?random=" + random + "&project_id=" + this.project_id + "&jenis_pekerjaan=" + Response.data.content.data[0].tipe_work + "&id_kegiatan=" + this.secretencData).then(
                        Responsecari => {
                            this.tahapanpekerjaan = Responsecari.data.content.data;
                        }
                    ).catch(error => {
                        console.log(error);
                        //this.ClearlocalStorage();
                        this.halamanloading = false;
                    });




                    mainAPIDataSingelcari.get("parastapainnovation_idkegiatanpmis-GetIdKegiatanPMIS?random=" + random + "&project_id=" + this.project_id + "&id_user=" + id_userpmis).then(
                        Responsecari => {
                            this.dataidpmis = [];
                            this.idpmis = [];
                            this.dataidpmis = Responsecari.data.content.data;
                            this.dataidpmis.forEach((item) => {
                                this.idpmis.push({
                                    label: item.nama_kegiatan,
                                    code: this.dataidpmis.indexOf(item) + 1,
                                    tag: item.id_kegiatan,
                                });
                            });
                            this.idpmis.unshift({
                                label: 'Pilih Salah Satu',
                                code: 0,
                                tag: '',
                            });
                        }
                    ).catch(error => {
                        console.log(error);
                        //this.ClearlocalStorage();
                        this.halamanloading = false;
                    });

                    if (Response.data.content.data[0].id_pmis == 0) {
                        this.defaultSelectedidpmis = {
                            code: 0,
                            label: 'Pilih Salah Satu',
                            tag: '',
                        };
                    }
                    else {
                        this.defaultSelectedidpmis = {
                            code: Response.data.content.data[0].id_pmis,
                            label: Response.data.content.data[0].Nama_Kegiatan,
                            tag: Response.data.content.data[0].id_pmis,
                        };
                        this.selectedidpmis = Response.data.content.data[0].id_pmis;
                    }

                    this.Penyedia = Response.data.content.data[0].KONTRAKTOR;
                    this.Mulai = Response.data.content.data[0].MULAI;
                    this.Selesai = Response.data.content.data[0].SELESAI;
                    this.Kontrak = Response.data.content.data[0].NOKONTRAK;
                    this.Nilai = this.G_numFormat(Response.data.content.data[0].NILAIKONTRAK);
                    this.Adendum = Response.data.content.data[0].ADENDUM;
                    this.OWP = this.G_numFormat(Response.data.content.data[0].OWP);
                    this.AWP = Response.data.content.data[0].AWP;
                    this.DIPA = Response.data.content.data[0].DIPA;
                    this.PDO = Response.data.content.data[0].PDO;

                    this.datatahun = Response.data.tahun;
                    this.jumlahtahun = Response.data.tahun.length;
                    this.Target = Response.data.content.data[0].TARGET;
                    this.Capaian = Response.data.content.data[0].PROGRES;
                    this.Realisasi = this.G_numFormat(Response.data.content.data[0].REALISASI_KUMULATIF);
                    this.TanggalData = Response.data.content.data[0].TANGGALDATA;
                    this.Keterangan = Response.data.content.data[0].KETERANGAN;
                    this.LATITUDE = Response.data.content.data[0].LATITUDE;
                    this.LONGITUDE = Response.data.content.data[0].LONGITUDE;
                    this.halamanloading = false;
                }
            ).catch(error => {
                swal.fire('Peringatan', error, 'error');
                this.halamanloading = false;
                return false;
            })
        },
        validasidata() {
            if ((this.selectedid_user == '') || (this.selectedid_user === null) || (this.selectedid_user === undefined)) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Pilih PIU..',
                });
                return false;
            }
            if ((this.selectedidpmis == '') || (this.selectedidpmis === null) || (this.selectedidpmis === undefined)) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Pilih Kegiatan PMIS..',
                });
                return false;
            }
            if (document.getElementById('Nama_Kegiatan').value == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Isikan Data',
                });
                document.getElementById('Nama_Kegiatan').focus();
                return false;
            }
            if ((this.selectedlokasi == '') || (this.selectedlokasi === null) || (this.selectedlokasi === undefined)) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Pilih Lokasi Kota..',
                });
                return false;
            }
            if (this.OWP == '0') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Isikan OWP..',
                });
                return false;
            }
            if (this.AWP == []) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Isikan AWP..',
                });
                return false;
            }
            if (this.DIPA == []) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Isikan AWP..',
                });
                return false;
            }
            if (this.Komponen == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Isikan Komponen..',
                });
                document.getElementById('Komponen').focus();
                return false;
            }

            if ((this.selectedjenispekerjaan == '') || (this.selectedjenispekerjaan === null) || (this.selectedjenispekerjaan === undefined)) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Pilih Jenis Pekerjaan..',
                });
                return false;
            }

            if (this.tahapanpekerjaan == []) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Isikan Tahapan Pekerjaan..',
                });
                return false;
            }

            if (this.TanggalData == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Isikan Tanggal Data..',
                });
                return false;
            }
            this.validasi = true;
            return;
        },
        simpan() {
            this.validasidata();
            if (this.validasi == false) {
                return false;
            }

            alert(this.selectedid_user);
            alert(this.selectedidpmis);
            alert(this.Nama_Kegiatan);
            alert(this.selectedlokasi);
            alert(this.OWP);
            return false;
            var fd = new FormData();
            fd.append("nama", this.nama);
            fd.append("nama_eng", this.nama_eng);
            fd.append("konten", this.konten);
            fd.append("konten_eng", this.konten_eng);
            fd.append("project_id", this.project_id);
            fd.append("filenya_beranda", document.getElementById('pic').value);
            fd.append("createdby", JSON.parse(localStorage.getItem("isistem")));

            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("parastapainnovation_beranda-AddInfoBeranda", fd).then(
                Response => {
                    if (Response.data.response == 'error') {
                        swal.fire('Peringatan', Response.data.message, 'error');
                    }
                    else {
                        swal.fire('Informasi', 'Data telah tersimpan..', 'success').then(function () {
                            window.location.replace("/InfoBeranda");
                        });
                    }
                }
            ).catch(function (error) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: error
                });
            }
            )
        },
        update() {
            //alert(JSON.stringify(this.PDO[0].Satuan));
            //alert(JSON.stringify(this.PDO[0].Ceklist));
            //return false;
            var kodepdo = '';
            var idceklist = '';
            var ceklist = '';
            var filenya_pdo = '';
            for (let i = 0; i < this.PDO.length; i++) {
                if (i == 0) {
                    kodepdo = kodepdo + this.PDO[i].id;
                }
                else {
                    kodepdo = kodepdo + '|' + this.PDO[i].id;
                }
                if (this.PDO[i].Satuan == 'Number' || this.PDO[i].Satuan == 'Nomor' || this.PDO[i].Satuan == 'Persentase' || this.PDO[i].Satuan == 'Kilometer' || this.PDO[i].Satuan == 'Jumlah') {
                    //alert('isian');
                    var idceklistdata = '';
                    var ceklistdata = '';
                    for (let x = 0; x < this.PDO[i].Ceklist.length; x++) {
                        if (x == 0) {
                            idceklistdata = idceklistdata + x;
                            ceklistdata = ceklistdata + document.getElementById('checkbox' + this.PDO[i].id + '-' + x).checked;
                        }
                        else {
                            idceklistdata = idceklistdata + '#' + x;
                            ceklistdata = ceklistdata + '#' + document.getElementById('checkbox' + this.PDO[i].id + '-' + x).checked;
                        }

                    }
                    var datafilenya_pdo ='';
                    for (let x = 0; x < this.PDO[i].CekInput.length; x++) {
                        if (x == 0) {
                            datafilenya_pdo = datafilenya_pdo + document.getElementById('filenya_pdo' + this.PDO[i].id + '-' + x).value;
                        }
                        else {
                            datafilenya_pdo = datafilenya_pdo +'??'+ document.getElementById('filenya_pdo' + this.PDO[i].id + '-' + x).value;
                        }
                    }
                    //alert(datafilenya_pdo);
                    //alert(document.getElementById('filenya_pdo' + this.PDO[i].id).value);

                }
                else if (this.PDO[i].Satuan == 'Dokumen') {
                    //alert('dokumen');
                    var idceklistdata = '';
                    var ceklistdata = '';
                    for (let x = 0; x < this.PDO[i].Ceklist.length; x++) {
                        if (x == 0) {
                            idceklistdata = idceklistdata + x;
                            ceklistdata = ceklistdata + document.getElementById('checkbox' + this.PDO[i].id + '-' + x).checked;
                        }
                        else {
                            idceklistdata = idceklistdata + '#' + x;
                            ceklistdata = ceklistdata + '#' + document.getElementById('checkbox' + this.PDO[i].id + '-' + x).checked;
                        }
                    }
                    var datafilenya_pdo ='';
                    for (let x = 0; x < this.PDO[i].CekInput.length; x++) {
                        if (x == 0) {
                            datafilenya_pdo = datafilenya_pdo + document.getElementById('filenya_pdo' + this.PDO[i].id + '-' + x).value;
                        }
                        else {
                            datafilenya_pdo = datafilenya_pdo +'??'+ document.getElementById('filenya_pdo' + this.PDO[i].id + '-' + x).value;
                        }
                    }
                    //var datafilenya_pdo = document.getElementById('filenya_pdo' + this.PDO[i].id).value;
                    //alert(document.getElementById('filenya_pdo' + this.PDO[i].id).value);
                }
                else {
                    var idceklistdata = '';
                    var ceklistdata = '';
                    for (let x = 0; x < this.PDO[i].Ceklist.length; x++) {
                        if (x == 0) {
                            idceklistdata = idceklistdata + x;
                            ceklistdata = ceklistdata + document.getElementById('checkbox' + this.PDO[i].id + '-' + x).checked;
                        }
                        else {
                            idceklistdata = idceklistdata + '#' + x;
                            ceklistdata = ceklistdata + '#' + document.getElementById('checkbox' + this.PDO[i].id + '-' + x).checked;
                        }
                    }
                    var datafilenya_pdo ='';
                    for (let x = 0; x < this.PDO[i].CekInput.length; x++) {
                        if (x == 0) {
                            datafilenya_pdo = datafilenya_pdo + document.getElementById('filenya_pdocek1' + this.PDO[i].id).checked + '*' + document.getElementById('filenya_pdocek2' + this.PDO[i].id+ '-' + x).checked;
                        }
                        else {
                            datafilenya_pdo = datafilenya_pdo +'??'+ document.getElementById('filenya_pdocek1' + this.PDO[i].id).checked + '*' + document.getElementById('filenya_pdocek2' + this.PDO[i].id+ '-' + x).checked;
                        }
                    }
                    //var datafilenya_pdo = document.getElementById('filenya_pdocek1' + this.PDO[i].id).checked + '*' + document.getElementById('filenya_pdocek2' + this.PDO[i].id).checked;
                    //alert(document.getElementById('filenya_pdocek1' + this.PDO[i].id).checked+'*'+document.getElementById('filenya_pdocek2' + this.PDO[i].id).checked);
                }
                if (i == 0) {
                    idceklist = idceklist + idceklistdata;
                    ceklist = ceklist + ceklistdata;
                    filenya_pdo = filenya_pdo + datafilenya_pdo;
                }
                else {
                    idceklist = idceklist + '|' + idceklistdata;
                    ceklist = ceklist + '|' + ceklistdata;
                    filenya_pdo = filenya_pdo + '|' + datafilenya_pdo;
                }
            }

            var tanggaltahun = new Date(this.Selesai);
            var tahun = tanggaltahun.getFullYear();
            //alert(this.project_id);
            //alert(this.secretencData);
            //alert(kodepdo);
            //alert(tahun);
            //alert(idceklist);
            //alert(ceklist);
            //alert(filenya_pdo);
            //alert(JSON.parse(localStorage.getItem("isistem")));
            //alert("Proses Update");
            //return false;

            var fd = new FormData();
            fd.append("project_id", this.project_id);
            fd.append("id_kegiatan", this.secretencData);
            fd.append("kodepdo", kodepdo);
            fd.append("tahun", tahun);
            fd.append("idceklist", idceklist);
            fd.append("ceklist", ceklist);
            fd.append("filenya_pdo", filenya_pdo);
            fd.append("updatedby", JSON.parse(localStorage.getItem("isistem")));
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var kode = encodeURIComponent(CryptoJS.AES.encrypt(this.secretencData, 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
            mainAPI.post("parastapainnovationmonev-ChangePDOIOS", fd).then(
                Response => {
                    if (Response.data.response == 'error') {
                        swal.fire('Peringatan', Response.data.message, 'error');
                    }
                    else {
                        swal.fire('Informasi', 'Data telah terupdate..', 'success').then(function () {
                            window.location.replace("/Monev/" + kode);
                        });
                    }
                }
            ).catch(function (error) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: error
                });
            }
            )
            return false;
        },
    },
    mounted() {
        this.getOtentifikasi();
        this.initialize();
        this.ambildatareff();
        if (this.secretencData != 'Tambah') {
            this.AmbilDataSingel();
        }
    }
}
</script>
<style>
.disabled {
    pointer-events: none;
    color: #e9ecef;
    cursor: not-allowed;
    background-image: none;
    background-color: #e9ecef;
    border-color: #e9ecef;
}
</style>